<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      size="small"
      resizable
      border
      :checkbox-config="{
        highlight: true,
        trigger: 'row',
      }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:containerAmount="{ row }">
        <span>{{ row.containerPriceAmount }}{{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:containerSalePrice="{ row }">
        <span
          >{{ row.containerSalePriceAmout }}{{ row.v_salesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  components: {},
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },

  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    clearCheck() {
      this.$refs.table.clearCheckboxRow()
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
